// Узкий экран или широкий. SMY-76
//
// Ниже контрольной точки кабинет не просто перекладывает блоки, а переносит
// их в другое место разметки: ряд остатков уезжает из шапки под неё, правая
// колонка становится свёрнутой строкой под артефактом. Переставить родителя
// средствами CSS нельзя, а рисовать оба варианта и гасить один — значит
// держать в дереве два одинаковых списка ссылок.
//
// `useSyncExternalStore`, а не эффект с состоянием: первая же отрисовка
// обязана знать ширину. С эффектом кадр рисовался бы по десктопной раскладке
// и тут же перестраивался — на телефоне это видимый прыжок.

import { useSyncExternalStore } from 'react'

import { BREAKPOINT } from './tokens.ts'

const QUERY = `(width < ${BREAKPOINT}px)`

const subscribe = (onChange: () => void): (() => void) => {
  const mq = window.matchMedia(QUERY)
  mq.addEventListener('change', onChange)
  return () => mq.removeEventListener('change', onChange)
}

/** Узкая раскладка: левая колонка в меню, правая — строкой под содержимым. */
export const useCompact = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    // Значение для окружения без окна (тесты, будущий SSR): широкая
    // раскладка — то, под что нарисованы макеты веба.
    () => false,
  )
